import { NgrxUtilsState } from "../model";

export namespace StateCacheSelector {
	export const isExpired =
		(key: string, expirationMs: number) =>
		(state: NgrxUtilsState): boolean => {
			const fetchedInfo = state.stateCache[key];
			if (!fetchedInfo) {
				return true;
			}

			// expiration cache
			return Date.now() > fetchedInfo.timestamp + expirationMs;
		};

	export const isFetchedOnServer =
		(key: string) =>
		(state: NgrxUtilsState): boolean =>
			state.stateCache[key]?.onServer;

	export const isFetched =
		(key: string) =>
		(state: NgrxUtilsState): boolean =>
			!!state.stateCache[key];
}
